'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var imagePlaceholder = require('./image-placeholder-e681e8b9.js');
var styles$x = require('./styles-6845ded1.js');

var Image = function (_a) {
    var src = _a.src, alt = _a.alt, className = _a.className, skeleton = _a.skeleton, props = tslib_es6.__rest(_a, ["src", "alt", "className", "skeleton"]);
    var defaultImagePlaceholder = src ? null : imagePlaceholder.img;
    var defaultLoadingValue = !!(src && skeleton);
    var _b = tslib_es6.__read(React.useState(defaultImagePlaceholder), 2), imagePlaceholder$1 = _b[0], setImagePlaceholder = _b[1];
    var _c = tslib_es6.__read(React.useState(defaultLoadingValue), 2), isLoading = _c[0], setIsLoading = _c[1];
    var onLoadComplete = React.useCallback(function () { return setIsLoading(false); }, [setIsLoading]);
    var onError = React.useCallback(function () {
        setImagePlaceholder(imagePlaceholder.img);
        if (skeleton) {
            setIsLoading(false);
        }
    }, [skeleton, setIsLoading]);
    if (skeleton) {
        return (React__default.createElement(React__default.Fragment, null,
            isLoading && (skeleton),
            React__default.createElement(styles$x.DivVisibilityContainer, { className: className, hide: isLoading },
                React__default.createElement("img", tslib_es6.__assign({ className: className, src: imagePlaceholder$1 || src, alt: alt, onError: onError, onLoad: onLoadComplete }, props)))));
    }
    return React__default.createElement("img", tslib_es6.__assign({ className: className, src: imagePlaceholder$1 || src, alt: alt, onError: onError }, props));
};

exports.Image = Image;
